// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1Kgdd","col":"styles_col__1J7aN"};